<template>
	<datatable
		v-model:items-selected="selected"
		:value="subgroups"
		:headers="headers"
		:loading="loading"
		:rows="10"
		data-key="subgroup"
		:filter-options="filterable ? filterOptions : undefined"
		:global-filter-fields="filterable ? ['subgroup', 'name', 'pgroup'] : undefined"
		:filter-display="filterable ? 'menu' : undefined"
		selectable
		clickable
		sortable
		:sort-by="sortBy"
		:sort-order="sortOrder">
		<template #row-subgroup="{ row }">
			{{ row.subgroup }}
		</template>

		<template #row-name="{ row }">
			{{ row.name }}
		</template>

		<template #row-pgroup="{ row }">
			{{ row.pgroup }}
		</template>
	</datatable>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'
	import { FilterMatchMode } from '@primevue/core/api'
	import type { Header } from '@/data/types/datatable'
	import type { SubGroup } from '@/data/schema/product'

	const props = withDefaults(
		defineProps<{
			subgroups?: SubGroup[]
			loading?: boolean
			selected?: SubGroup[]
			dataKey?: string
			filterable?: boolean
			sortBy?: string | undefined
			sortOrder?: number | undefined
		}>(),
		{
			subgroups: () => [],
			loading: false,
			selected: () => [],
			dataKey: 'subgroup',
			filterable: false,
			sortBy: undefined,
			sortOrder: undefined
		}
	)

	const emit = defineEmits(['update:selected'])

	const selected = computed({
		get: () => props.selected,
		set: (value) => {
			emit('update:selected', value)
		}
	})

	const filterOptions = {
		subgroup: { value: null, matchMode: FilterMatchMode.CONTAINS },
		name: { value: null, matchMode: FilterMatchMode.CONTAINS },
		pgroup: { value: null, matchMode: FilterMatchMode.CONTAINS }
	}

	const headers = computed<Header[]>(() => [
		{ value: 'subgroup', text: 'Code', props: { sortable: true, filter: props.filterable } },
		{ value: 'name', text: 'Name', props: { sortable: true, filter: props.filterable } },
		{ value: 'pgroup', text: 'PGroup', props: { sortable: true, filter: props.filterable } }
	])
</script>
